import useAuth from '../hooks/useAuth';

// Render-gate. <RoleGate master>...</RoleGate> only renders when the
// logged-in user is a master. Use for surface elements (buttons, cards).
// For full pages, use the route-level guards in routes/index.jsx.

export default function RoleGate({ master = false, children, fallback = null }) {
  const { me } = useAuth();
  if (master && !(me && me.isMaster === true)) return fallback;
  return <>{children}</>;
}
